<div class="analytics-container">

  <!-- Header -->
  <div class="analytics-header">
    <h2>Dashboard</h2>

    <div class="filter-card">
      <div class="filter-bar">
        <!-- View By -->
        <div class="filter-group">
          <span class="filter-icon"><i class="fa fa-filter"></i></span>
          <select [(ngModel)]="filterType" (change)="onFilterTypeChange()" class="form-control filter-select">
            <option value="DAY">Day</option>
            <option value="MONTH">Month</option>
            <option value="YEAR">Year</option>
            <option value="ALL">All</option>
          </select>
        </div>

        <!-- DAY: single date picker -->
        <div class="filter-group" *ngIf="filterType === 'DAY'">
          <span class="filter-icon"><i class="fa fa-calendar"></i></span>
          <input type="date" [(ngModel)]="selectedDay" (change)="onSelectionChange()" class="form-control" />
        </div>

        <!-- MONTH: separate Year + Month dropdowns -->
        <ng-container *ngIf="filterType === 'MONTH'">
          <div class="filter-group">
            <span class="filter-icon"><i class="fa fa-calendar-o"></i></span>
            <select [(ngModel)]="selectedMonthYear" (change)="onSelectionChange()" class="form-control filter-select">
              <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
            </select>
          </div>
          <div class="filter-group">
            <span class="filter-icon"><i class="fa fa-calendar-o"></i></span>
            <select [(ngModel)]="selectedMonthNum" (change)="onSelectionChange()" class="form-control filter-select">
              <option *ngFor="let m of monthNames" [ngValue]="m.value">{{ m.label }}</option>
            </select>
          </div>
        </ng-container>

        <!-- YEAR: year dropdown -->
        <div class="filter-group" *ngIf="filterType === 'YEAR'">
          <span class="filter-icon"><i class="fa fa-calendar-o"></i></span>
          <select [(ngModel)]="selectedYear" (change)="onSelectionChange()" class="form-control filter-select">
            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="status-state">
    <span class="spinner-border spinner-border-sm" role="status"></span>&nbsp;Loading analytics&hellip;
  </div>

  <!-- Count cards row -->
  <div *ngIf="!isLoading" class="bar-charts-row">

    <!-- Units Created -->
    <div class="stat-card stat-card--blue">
      <div class="stat-card__header">
        <div class="stat-card__icon stat-card__icon--blue">
          <em class="fa fa-building"></em>
        </div>
        <span class="stat-card__title">Units Created</span>
      </div>
      <div class="stat-card__body">
        <span class="stat-card__count">{{ totalUnitsCreated }}</span>
        <span class="stat-card__sub">Total Units</span>
      </div>
      <div class="stat-bar-track">
        <div class="stat-bar stat-bar--blue"></div>
      </div>
    </div>

    <!-- Gateway Commissioned -->
    <div class="stat-card stat-card--green">
      <div class="stat-card__header">
        <div class="stat-card__icon stat-card__icon--green">
          <em class="fa fa-wifi"></em>
        </div>
        <span class="stat-card__title">Gateway</span>
      </div>
      <div class="stat-card__body">
        <span class="stat-card__count">{{ totalGatewayCommissioned }}</span>
        <span class="stat-card__sub">Commissioned</span>
      </div>
      <div class="stat-bar-track">
        <div class="stat-bar stat-bar--green"></div>
      </div>
    </div>

    <!-- CPIB2 Commissioned -->
    <div class="stat-card stat-card--orange">
      <div class="stat-card__header">
        <div class="stat-card__icon stat-card__icon--orange">
          <em class="fa fa-microchip"></em>
        </div>
        <span class="stat-card__title">CPIB2</span>
      </div>
      <div class="stat-card__body">
        <span class="stat-card__count">{{ totalCpib2Commissioned }}</span>
        <span class="stat-card__sub">Commissioned</span>
      </div>
      <div class="stat-bar-track">
        <div class="stat-bar stat-bar--orange"></div>
      </div>
    </div>

    <!-- ePAL Customer Devices Commissioned -->
    <div class="stat-card stat-card--purple">
      <div class="stat-card__header">
        <div class="stat-card__icon stat-card__icon--purple">
          <em class="fa fa-mobile"></em>
        </div>
        <span class="stat-card__title">ePAL Customer Devices</span>
      </div>
      <div class="stat-card__body">
        <span class="stat-card__count">{{ totalEpalCustomerDevices }}</span>
        <span class="stat-card__sub">Commissioned</span>
      </div>
      <div class="stat-bar-track">
        <div class="stat-bar stat-bar--purple"></div>
      </div>
    </div>

    <!-- ePAL Mechanic Devices Commissioned -->
    <div class="stat-card stat-card--teal">
      <div class="stat-card__header">
        <div class="stat-card__icon stat-card__icon--teal">
          <em class="fa fa-wrench"></em>
        </div>
        <span class="stat-card__title">ePAL Mechanic Devices</span>
      </div>
      <div class="stat-card__body">
        <span class="stat-card__count">{{ totalEpalMechanicDevices }}</span>
        <span class="stat-card__sub">Commissioned</span>
      </div>
      <div class="stat-bar-track">
        <div class="stat-bar stat-bar--teal"></div>
      </div>
    </div>

    <!-- ePAL Gateway -->
    <div class="stat-card stat-card--slate">
      <div class="stat-card__header">
        <div class="stat-card__icon stat-card__icon--slate">
          <em class="fa fa-plug"></em>
        </div>
        <span class="stat-card__title">ePAL Gateway</span>
      </div>
      <div class="stat-card__body">
        <span class="stat-card__count">{{ totalEpalGateway }}</span>
        <span class="stat-card__sub">Commissioned</span>
      </div>
      <div class="stat-bar-track">
        <div class="stat-bar stat-bar--slate"></div>
      </div>
    </div>

  </div>
</div>